import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AppState } from '@app/reducers';
import { ReusablePrimeNGTableFeatureService, SnackbarService, currentComponentPageBasedPermissionsSelector$ } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { CrudType, LoggedInUserModel, ModulesBasedApiSuffix, addDefaultTableObjectProperties, checkUserPermissionsByCategory, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared/utils';
import { loggedInUserData } from '@modules/others';
import { IT_MANAGEMENT_COMPONENT, UserModuleApiSuffixModels } from '@modules/user/shared/utils';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { SuburbAddEditComponent } from './';
@Component({
  selector: 'app-suburblist',
  templateUrl: './suburblist.component.html',
})
export class SuburblistComponent extends PrimeNgTableVariablesModel implements OnInit {
  searchCol: any = {};
  primengTableConfigProperties: any = {
    tableCaption: "Suburb",
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'IT Management ', relativeRouterUrl: '' }, { displayName: 'Suburb List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Suburb',
          dataKey: 'suburbId',
          checkBox: true,
          enableRowDelete: true,
          enableAction: true,
          enableMultiDeleteActionBtn: true,
          columns: [{ field: 'suburbName', header: 'Suburb Name' },
          { field: 'provinceName', header: 'Province Name' },
          { field: 'cityName', header: 'City Name' },
          { field: 'tierName', header: 'Tier Name' },
          { field: 'createdDate', header: 'Created Date', isDateTime: true },
          { field: 'isActive', header: 'Status' }
          ],
          apiSuffixModel: UserModuleApiSuffixModels.SUBURB,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }]
    }
  }

  constructor(private httpService: CrudService,
    private dialog: MatDialog,
    private rxjsService: RxjsService,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService,
    private store: Store<AppState>, private snackbarService: SnackbarService) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getSuburb();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][IT_MANAGEMENT_COMPONENT.SUBURB]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  onCRUDRequested(type: CrudType | string, row?, searchCol?: any): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.CREATE)) {
          this.OpenDialogWindow(CrudType.CREATE, row);
        }
        break;
      case CrudType.GET:
        switch (this.selectedTabIndex) {
          case 0:
            this.searchCol = searchCol;
            this.getSuburb(
              row["pageIndex"], row["pageSize"], this.searchCol);
            break;
        }
        break;
      case CrudType.EDIT:
        this.OpenDialogWindow(CrudType.EDIT, row);
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory.bind(this, CrudType.EDIT)) {
          this.OpenDialogWindow(CrudType.VIEW, row);
        }
        break;
      case CrudType.STATUS_POPUP:
        this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (!result) {
              this.dataList[searchCol].isActive = this.dataList[searchCol].isActive ? false : true;
            }
          });
        break;
      case CrudType.DELETE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.ROW_DELETE)) {
          this.reusablePrimeNGTableFeatureService.openDynamicDeleteDialog(this.selectedTabIndex, this.selectedRows,
            this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
              if (result) {
                this.selectedRows = [];
                this.getSuburb();
              }
            });
        }
        break;
    }
  }

  getSuburb(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    otherParams = { ...this.searchCol };
    this.httpService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.SUBURB,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((response) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources
        this.totalRecords = response.totalCount;
        this.loading = false;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  private OpenDialogWindow(type: CrudType | string, suburb) {
    const dialogReff = this.dialog.open(SuburbAddEditComponent, { width: '450px', data: suburb ? suburb : {}, disableClose: true });
    dialogReff.afterClosed().subscribe(result => {
      if (result) {
        this.getSuburb();
      }
    });
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }
}
